import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { startIntegration } from 'scenes/Integrations/sources/integrations';

import { start } from '../queryKeyFactory';
import { errorMessageGetter } from './errorMessageGetter';

export const useStart = (type) => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const startMutation = useMutation(start(), startIntegration, {
    successMessage: () => `Integration activated`,
    errorMessage: errorMessageGetter,
    refresh: true,
  });

  const handleStart = async ({ id }) => {
    await showModal({
      title: `Activate Integration?`,
      bodyText: `#${id}`,
      confirmActionLabel: 'Activate',
    });
    await startMutation.mutateAsync({
      id,
      configurationTypeId: type,
    });
  };

  return [handleStart, startMutation];
};
